import { Message } from '../models/resources'

export default {
  getMessageThreads(context) {
    return Message.query().then((res) => {
      context.commit('messageThreads', res.body)
      return res.body
    })
  },

  getMessageThread(context, userId) {
    return Message.thread({user_id: userId}).then((res) => {
      context.commit('messageThread', res.body)
      return res.body
    })
  },

  sendMessage(context, {recipient_id, body}) {
    return Message.save({}, {recipient_id, body}).then((res) => {
      context.commit('appendMessage', res.body)
      return res.body
    })
  },

  markThreadRead(context, userId) {
    return Message.markRead({user_id: userId}, {}).then(() => {
      context.commit('threadRead', userId)
      return context.dispatch('getUnreadMessagesCount')
    })
  },

  getUnreadMessagesCount(context) {
    return Message.unreadCount().then((res) => {
      context.commit('unreadMessagesCount', res.body.unread_count)
      return res.body.unread_count
    })
  },

  getMessageSettings(context) {
    return Message.settings().then((res) => {
      context.commit('messageSettings', res.body)
      return res.body
    })
  },

  updateMessageSettings(context, settings) {
    return Message.updateSettings({}, settings).then((res) => {
      // The response echoes the toggles but not the blocked list, so keep
      // whatever the settings screen already loaded.
      context.commit('messageSettings', Object.assign({}, context.state.messageSettings, res.body))
      return res.body
    })
  },

  blockUserFromMessaging(context, userId) {
    return Message.block({}, {user_id: userId}).then(() => context.dispatch('getMessageSettings'))
  },

  unblockUserFromMessaging(context, userId) {
    return Message.unblock({user_id: userId}).then(() => context.dispatch('getMessageSettings'))
  },
}
